var map = {
  "./de.json": "99160",
  "./en.json": "52196",
  "./es-419.json": "21432",
  "./es.json": "11107",
  "./fr-CA.json": "2502",
  "./fr.json": "80063",
  "./hu.json": "43140",
  "./it.json": "78474",
  "./ja.json": "41522",
  "./nl.json": "29357",
  "./pt.json": "60991",
  "./sv.json": "60054"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = function() { return Object.keys(map); };
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 75445;
